import barcodeImage from "./barcode-2d.png";

function TwoDimensionalBarcodeField() {
  return <img src={barcodeImage} alt="" />;
}

export default TwoDimensionalBarcodeField;
